<template>
  <div
      class="position-relative"
      ref="trigger"
  >
    <!-- Bootstrap-like select -->
    <div
        class="custom-select d-flex"
        :class="{ 'text-muted': !selectedLabel, 'disabled': disabled }"
        @click="!disabled && toggle()"
    >
      {{ selectedLabel || placeholder }}
    </div>

    <!-- TELEPORT -->
    <portal :to="portalTarget">
      <div
          v-if="open"
          class="bs-dropdown"
          :style="style"
          ref="dropdown"
      >
        <input
            type="text"
            class="form-control form-control-sm search-input"
            placeholder="Поиск..."
            v-model="search"
        />

        <div class="list-group list-group-flush">
          <!--          <b-button size="sm"-->
          <!--              v-for="opt in filtered"-->
          <!--              :key="opt[valueKey]"-->
          <!--              type="button"-->
          <!--              class="list-group-item list-group-item-action"-->
          <!--              @click="selectItem(opt)"-->
          <!--          >-->
          <!--            {{ opt[labelKey] }}-->
          <!--          </b-button>-->
          <ul class="select-list">
            <li v-if="addNullElement" :key="null" @click="selectItem(null)">
              {{ placeholder }}
            </li>
            <li v-for="opt in filtered" :key="opt[valueKey]"
                @click="selectItem(opt)">
              {{ opt[labelKey] }}
            </li>
          </ul>

          <div
              v-if="!filtered.length"
              class="select-list text-center"
          >
            - Элементы не найдены -
          </div>
        </div>
      </div>
    </portal>
  </div>
</template>

<script>
export default {
  name: 'BsSearchSelect',

  props: {
    value: null,
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    portalTarget: {
      type: String,
      default: 'body'
    },
    placeholder: {
      type: String,
      default: 'Выбрать...'
    },
    addNullElement: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      open: false,
      search: '',
      style: {},
      scrollPosition: 0
    }
  },

  computed: {
    selectedLabel() {
      const item = this.options.find(
          o => o[this.valueKey] === this.value
      )
      return item && item[this.labelKey]
    },
    filtered() {
      const s = this.search.toLowerCase()
      return this.options.filter(o =>
          o[this.labelKey].toLowerCase().includes(s)
      )
    }
  },
  methods: {
    toggle() {
      this.open ? this.close() : this.openDropdown()
    },

    openDropdown() {
      const rect = this.$refs.trigger.getBoundingClientRect()

      this.style = {
        position: 'fixed',
        top: rect.bottom + window.scrollY + 'px',
        left: rect.left + window.scrollX + 'px',
        width: rect.width + 'px',
        zIndex: 1060
      }

      this.open = true
      document.addEventListener('click', this.onClickOutside)
    },

    close() {
      this.open = false
      this.search = ''
      document.removeEventListener('click', this.onClickOutside)
    },

    selectItem(opt) {
      if (!opt) {
        this.$emit('input', null)
      } else {
        this.$emit('input', opt[this.valueKey])
      }
      this.close()
    },

    onClickOutside(e) {
      const trigger = this.$refs.trigger
      const dropdown = this.$refs.dropdown

      if (
          !trigger.contains(e.target) &&
          (!dropdown || !dropdown.contains(e.target))
      ) {
        this.close()
      }
    }
  },

  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside)
  }
}
</script>

<style>
.bs-dropdown {
  background-color: rgba(103, 100, 100, 0.9);
  color: white;
  border-radius: .5rem;
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .175);
  max-height: 400px;
  overflow: hidden;
}

.bs-dropdown .list-group {
  max-height: 240px;
  overflow-y: auto;
}

.select-list {
  list-style: none;
  padding: 1px; /* Убираем отступ слева */
  margin: 1px; /* Убираем внешние отступы */
  line-height: 1.4;
}

.select-list li {
  margin: 1px;
  line-height: 1.4;
  padding: 6px;
}

.select-list li:hover {
  background-color: #5690cd; /* Светло‑голубой при наведении */
  color: white; /* Тёмно‑синий текст */
  cursor: pointer;
  border-radius: .5rem;
}

.custom-select {
  font-size: 0.875rem; /* как у form-control sm */
  line-height: 1.5; /* стандартное для sm */
  padding: 0.25rem 0.5rem; /* вертикальные отступы как у sm */
  height: 30px; /* фиксируем высоту */
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.position-relative {
  margin: 0;
  padding: 0;
  max-width: 100%;
  width: 100%;
}

.search-input {
  background: transparent !important;
  color: white !important;
  border: none;
  outline: none;
  backdrop-filter: blur(4px);
}

/* Дополнительно: стилизуем placeholder */
.search-input::placeholder {
  color: rgba(255, 255, 255, 0.6); /* полупрозрачный белый */
  opacity: 1; /* для совместимости с разными браузерами */
}

/* При фокусе можно добавить лёгкое свечение */
.search-input:focus {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
}

/* Стилизуем полосу прокрутки */
.bs-dropdown .list-group::-webkit-scrollbar {
  width: 8px; /* Ширина скроллбара */
}

.bs-dropdown .list-group::-webkit-scrollbar-track {
  background: rgba(103, 100, 100, 0.6); /* Темный трек (как фон) */
  border-radius: 4px;
}

.bs-dropdown .list-group::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3); /* Светлый ползунок */
  border-radius: 4px;
}

.bs-dropdown .list-group::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5); /* При наведении */
}

/* Для Firefox */
.bs-dropdown .list-group {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) /* ползунок */ rgba(103, 100, 100, 0.6); /* трек */
}

.custom-select.disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
  pointer-events: none;
  border: 1px solid #dee2e6;
  opacity: 0.7;
}
</style>
